// extracted by mini-css-extract-plugin
export default {"containerSearch":"SearchResults_containerSearch__FYQv5","footer":"SearchResults_footer__EqEfR"};